var _effectorFileName = "/builds/gmini/front-ui-kit/src/Header/Header.tsx";
import React from 'react';
import { Box } from '../Box';
import { PageTitle } from '../PageTitle';
import { UserProfile } from '../UserProfile/UserProfile';
import { AppBar, Separator } from './Header.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Header = /*#__PURE__*/React.memo(({
  title,
  titleSecondary,
  brand,
  rightButton,
  onLogout,
  userInfo,
  onProfileClick,
  brandSecondary
}) => {
  const handleLogout = React.useCallback(() => {
    onLogout();
  }, [onLogout]);
  const fullName = userInfo ? userInfo.name : '';
  return /*#__PURE__*/_jsxs(AppBar, {
    children: [brand, /*#__PURE__*/_jsx(Separator, {}), brandSecondary && /*#__PURE__*/_jsxs(_Fragment, {
      children: [brandSecondary, /*#__PURE__*/_jsx(Separator, {})]
    }), titleSecondary, title && /*#__PURE__*/_jsx(PageTitle, {
      "data-test-id": title,
      children: title
    }), /*#__PURE__*/_jsx(Box, {
      mr: 2,
      children: rightButton
    }), /*#__PURE__*/_jsx(UserProfile, {
      onLogout: handleLogout,
      userName: fullName,
      onProfileClick: onProfileClick,
      email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email
    })]
  });
});
Header.displayName = 'Header';